export const CONFETTI_BURST_EVENT = 'confetti-burst'

export function dispatchConfettiBurst(detail?: Record<string, unknown>) {
    window.dispatchEvent(new CustomEvent(CONFETTI_BURST_EVENT, { detail }))
}
